import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";
import { useVariant } from "@unleash/proxy-client-react";

import { Info2Icon } from "../../../icons";
import { UnleashFlags } from "../../../../constants";

export const MainPageAlertBanner: FC = () => {
  const variant = useVariant(UnleashFlags.showAlertBanner);
  const text = variant.payload?.value;

  if (typeof text !== "string" || !text.trim()) {
    return null;
  }

  return (
    <HStack
      alignItems="flex-start"
      backgroundColor="gold.50"
      border="1px solid"
      borderColor="gold.500"
      borderRadius="13px"
      px="11px"
      py="9px"
    >
      <Info2Icon color="gold.500" mr="4px" />

      <Text fontSize="12.5px" lineHeight="17px" wordBreak="break-word" overflowWrap="break-word">
        {text}
      </Text>
    </HStack>
  );
};
